import React, { Fragment, useState } from "react";
import {  Header, Icon } from "semantic-ui-react";
import PropTypes from "prop-types";
import { Animated } from "react-animated-css";
import Bottomslider from "../components/BottomSheet";
import Interview from "../components/Interview";
/**
 * @author
 * @function Base
 * Base higher order component with header and footer
 **/

const Base = ({
  title = "My Title",
  description = "My desription",
  visibleProp,
  hostortBackType,
  history,
  children
}) => {
  const [gotValue, setGotValue] = useState("");

  const onTextSend = value => {
    setGotValue(value);
  };
  return (
    <Fragment>
      <Header textAlign="center" size="large" style={commonHeader} as="h2">
        {/* <LogoHeader /> */}

        {title !== "Home" && title !== "Overview" ? (
          <p onClick={hostortBackType}>
            <Icon
              name="arrow left"
              size="small"
              style={{ float: "left", paddingTop: "6px" }}
            />
          </p>
        ) : (
          ""
        )}

        {title === "Overview" && (
          <>
            <span style={{ marginLeft: "60px", float: "left" }}>
              Quick Links
            </span>
            <span style={{ marginRight: "130px", float: "right" }}>
              Projects
            </span>
          </>
        )}
        {title}
      </Header>
      <Fragment
        fluid
        style={{ margin: "0px", padding: "0px", minHeight: "650px" }}
      >
        {children}
      </Fragment>
      {/* <div style = {{display : !visibleProp ? 'none' : ''}}> */}

      <Animated
        animationIn="fadeInLeftBig"
        animationOut="fadeOutLeftBig"
        isVisible={visibleProp}
        style={commonFooter}
      >
        <Bottomslider onTextSend={onTextSend}>
          <Interview value={gotValue} />
        </Bottomslider>
      </Animated>
      {/* </div> */}
    </Fragment>
  );
};

Base.propTypes = {
  children: PropTypes.element.isRequired
};

export default Base;

const commonHeader = {
  // textAlign: "center",
  fontWeight: "600",
  display: "block",
  padding: "8px",
  backgroundColor: "#FFFFFF",
  boxShadow: "0px 3px 28px rgba(0, 0, 0, 0.08)"
};

const commonFooter = {
  position: "fixed",
  bottom: 0,
  right: 0,
  borderRadius: "15px 12px",
  backgroundColor: "#FBC91B",
  fontWeight: "600",
  // padding: "35px",

  width: "100%"
};
